import type { XZReport } from "../IReports"

const getRandInt = (max: number) =>
  Math.floor(Math.random() * max)

export const getMockXZReport = (): XZReport => {
  const saleCount = getRandInt(20)
  const saleAmount = getRandInt(saleCount * 2000)
  const voidCount = getRandInt(Math.ceil(saleCount * 0.2))
  const voidAmount = getRandInt(voidCount * 2000)
  const cashbackCount = getRandInt(
    Math.ceil(saleCount * 0.1)
  )
  const cashbackAmount = getRandInt(cashbackCount * 2000)
  const gratuityCount = getRandInt(
    Math.ceil(saleCount * 0.3)
  )
  const gratuityAmount = getRandInt(gratuityCount * 500)
  const refundCount = getRandInt(
    Math.ceil(saleCount * 0.05)
  )
  const refundAmount = getRandInt(
    Math.max(saleAmount, refundCount * 2000)
  )

  return {
    headerFields: {
      TID: "1234",
      Date: "2025-07-24",
      Time: "12:21",
    },
    fromReceiptNo: "01",
    toReceiptNo: "10",

    saleCount: saleCount,
    saleAmount: saleAmount,
    voidCount: voidCount,
    voidAmount: voidAmount,
    cashbackCount: cashbackCount,
    cashbackAmount: cashbackAmount,
    gratuityCount: gratuityCount,
    gratuityAmount: gratuityAmount,
    refundCount: refundCount,
    refundAmount: refundAmount,

    completionCount: 0,
    completionAmount: 0,

    preAuthCount: 0,
    preAuthAmount: 0,
    preAuthTopUpCount: 0,
    preAuthTopUpAmount: 0,
    preAuthCancelledCount: 0,
    preAuthCancelledAmount: 0,

    totalCount:
      voidCount +
      cashbackCount +
      gratuityCount +
      refundCount +
      saleCount,
    totalAmount:
      voidAmount +
      cashbackAmount +
      gratuityAmount +
      refundAmount +
      saleAmount,

    terminalPrintedNativeReceipt: false,
    nativeReceiptLines: [],
    payloadJson: "{}",
  }
}
